var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var RxFilled = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", __assign({ fillRule: "evenodd", clipRule: "evenodd", d: "M18.75 0H5.25C4.00736 0 3 0.976833 3 2.18182V21.8182C3 23.0232 4.00736 24 5.25 24H18.75C19.9926 24 21 23.0232 21 21.8182V2.18182C21 0.976833 19.9926 0 18.75 0ZM7.5 5.45455H10.3125C12.4871 5.45455 14.25 7.164 14.25 9.27273V9.81818C14.25 10.8849 13.7237 11.8324 12.9093 12.4298L14.25 13.7299L15.7045 12.3195C16.1438 11.8935 16.8562 11.8935 17.2955 12.3195C17.7348 12.7455 17.7348 13.4363 17.2955 13.8623L15.841 15.2727L17.2955 16.6832C17.7348 17.1092 17.7348 17.7999 17.2955 18.2259C16.8562 18.652 16.1438 18.652 15.7045 18.2259L14.25 16.8155L12.7955 18.2259C12.3562 18.652 11.6438 18.652 11.2045 18.2259C10.7652 17.7999 10.7652 17.1092 11.2045 16.6832L12.659 15.2727L10.409 13.0909H8.625V16.3636C8.625 16.9661 8.12132 17.4545 7.5 17.4545C6.87868 17.4545 6.375 16.9661 6.375 16.3636V6.54545C6.375 5.94296 6.87868 5.45455 7.5 5.45455ZM10.875 10.9091C11.4963 10.9091 12 10.4207 12 9.81818V9.27273C12 8.36899 11.2445 7.63636 10.3125 7.63636H8.625V10.9091H10.875Z", fill: "currentColor" }, props)) })));
};
